import React, { useEffect, useState, useContext } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import context from '../context/recipesContext';

import RecipeCardFood from '../components/RecipeCardFood';
import { getMealAreas } from '../services/fetchNationality';

import '../App.css';

function ExploreFoodsNationalities() {
  const [areas, setAreas] = useState([]);
  const {
    foods,
    setFilterFoods,
  } = useContext(context);

  useEffect(() => {
    async function fetchAreas() {
      const areaList = await getMealAreas();
      setAreas(areaList);
    }
    fetchAreas();
  }, []);

  const handleClick = ({ target }) => {
    if (target.value === 'All') {
      setFilterFoods({ filter: 'name', value: '' });
    } else {
      setFilterFoods({ filter: 'nationality', value: target.value });
    }
  };

  return (
    <div className="nationality-page">
      <Header Title="Explore Nationalities" />
      <div className="n-main">
        <label htmlFor="selectNationalities">
          <select
            className="n-select"
            data-testid="explore-by-nationality-dropdown"
            onChange={ handleClick }
          >
            <option value="All" data-testid="All-option">
              All
            </option>
            {areas.map(({ strArea: area }) => (
              <option
                key={ area }
                value={ area }
                data-testid={ `${area}-option` }
              >
                {area}
              </option>
            ))}
          </select>

          <div className="n-foods">
            {foods.map((recipe, index) => (
              <RecipeCardFood
                key={ index }
                index={ index }
                recipe={ recipe }
              />
            ))}
          </div>
        </label>
      </div>
      <Footer />
    </div>
  );
}

export default ExploreFoodsNationalities;
